// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as EditOrderRepo from "./EditOrderRepo.bs.js";
import * as DummyEditOrderRepo from "./DummyEditOrderRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyEditOrderRepo.EditOrderRepo;
  } else {
    return EditOrderRepo.EditOrderRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
